export default {
    MENU_TITLE: 'My account',
    DASHBOARD_MENU_LABEL: 'My Hub',
    DASHBOARD_SETTINGS_MENU_LABEL: 'My Settings',
    DASHBOARD_SETTINGS_MENU_SUBTITLE_LABEL: 'Personal info & passwords',
    DASHBOARD_INBOX_MENU_LABEL: 'My Inbox',
    EYE_VISION_SECTION_MENU_TITLE: 'eye & vision care',
    EYE_EXAMS_MENU_LABEL: 'My Eye exams',
    MYAPPOINTMENTS_IN_STORE_SERVICES_MENU_LABEL: 'In-store services',
    PURCHASES_SECTION_MENU_TITLE: 'Purchases',
    PURCHASES_ONLINE_ORDERS_MENU_LABEL: 'My Orders',
    MYPURCHASES_IN_STORE_PURCHASES_MENU_LABEL: 'In-store purchases',
    FAVORITES_SECTION_MENU_TITLE: 'favorites',
    MYPROFILE_PERSONAL_DETAILS_MENU_LABEL: 'Personal details',
    MYPROFILE_SETTINGS_MENU_LABEL: 'My Settings',
    MYPROFILE_INBOX_MENU_LABEL: 'My Inbox',
    FAVORITES_MY_STORES_MENU_LABEL: 'My Stores',
    PURCHASES_PAYMENT_METHODS_MENU_LABEL: 'My Payment methods',
    FAVORITES_SAVED_ITEMS_MENU_LABEL: 'My Saved items',
    LOGOUT_MENU_LABEL: 'Logout',
    LOGOUT_MOBILE_MENU_LABEL: 'Log out',
    DASHBOARD_MANAGE_EYE_EXAMS_EMPTY_CARD_TITLE: 'Manage eye exams',
    DASHBOARD_MY_STORE_EMPTY_CARD_TITLE: 'My Stores',
    DASHBOARD_FIND_YOUR_LOOK_EMPTY_CARD_TITLE: 'Find your look',
    DASHBOARD_MY_FAVORITES_EMPTY_CARD_TITLE: 'My Saved Items',
    DASHBOARD_MY_ORDERS_EMPTY_CARD_TITLE: 'My orders',
    DASHBOARD_MY_INSTORE_APPOINTMENT_EMPTY_CARD_TITLE: 'My in-store appointment',
    DASHBOARD_MANAGE_EYE_EXAMS_EMPTY_CARD_CTA_LABEL: 'Manage Now',
    DASHBOARD_MY_STORE_EMPTY_CARD_CTA_LABEL: 'Search',
    DASHBOARD_FIND_YOUR_LOOK_EMPTY_CARD_CTA_LABEL: 'Start Now',
    DASHBOARD_MY_FAVORITES_EMPTY_CARD_CTA_LABEL: 'Shop Now',
    DASHBOARD_MY_ORDERS_EMPTY_CARD_CTA_LABEL: 'Shop Now',
    DASHBOARD_MY_INSTORE_APPOINTMENT_EMPTY_CARD_CTA_LABEL: 'Book An Appointment',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_TITLE: 'Eye Exams',
    DASHBOARD_MY_STORE_CARD_TITLE: 'My Stores',
    DASHBOARD_FIND_YOUR_LOOK_CARD_TITLE: 'Find your look',
    DASHBOARD_MY_FAVORITES_CARD_TITLE: 'My Saved Items',
    DASHBOARD_MY_ORDERS_CARD_TITLE: 'My orders',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_TITLE: 'My in-store appointments',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_CTA_LABEL: 'View All Eye Exams',
    DASHBOARD_MY_STORE_CARD_CTA_LABEL: 'View All Stores',
    DASHBOARD_FIND_YOUR_LOOK_CARD_CTA_LABEL: 'Start Now',
    DASHBOARD_MY_FAVORITES_CARD_CTA_LABEL: 'View All',
    DASHBOARD_MY_ORDERS_CARD_CTA_LABEL: 'View All Orders',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_CTA_LABEL: 'View All Appointments',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_SUBTITLE_SINGULAR_LABEL: '1 appointment',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_SUBTITLE_PLURAL_LABEL: '{TOTAL} appointments',
    DASHBOARD_MY_STORE_CARD_SUBTITLE_SINGULAR_LABEL: '1 favorite store',
    DASHBOARD_MY_STORE_CARD_SUBTITLE_PLURAL_LABEL: '{TOTAL} favorite stores',
    DASHBOARD_MY_FAVORITES_CARD_SUBTITLE_PLURAL_LABEL: '{TOTAL}  saved items',
    DASHBOARD_MY_FAVORITES_CARD_SUBTITLE_SINGULAR_LABEL: '1 saved item',
    DASHBOARD_MY_ORDERS_CARD_SUBTITLE_SINGULAR_LABEL: '1 order',
    DASHBOARD_MY_ORDERS_CARD_SUBTITLE_PLURAL_LABEL: '{TOTAL} orders',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_SUBTITLE_SINGULAR_LABEL: '1 appointment',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_SUBTITLE_PLURAL_LABEL: ' {TOTAL} appointments',
    DASHBOARD_MANAGE_EYE_EXAMS_EMPTY_CARD_TEXT: "You don't have any exams scheduled right now.",
    DASHBOARD_MY_STORE_EMPTY_CARD_TEXT:
        'Find a store near you and save details for easy access later.',
    DASHBOARD_FIND_YOUR_LOOK_EMPTY_CARD_TEXT:
        'Find the best eyeglasses or sunglasses for your face shape. We’re here to help you shine.',
    DASHBOARD_MY_FAVORITES_EMPTY_CARD_TEXT:
        'Browse the latest styles and save your favorites to try on at a store near you.',
    DASHBOARD_MY_ORDERS_EMPTY_CARD_TEXT: 'Your order history is empty. Let’s change that!',
    DASHBOARD_MY_INSTORE_APPOINTMENT_EMPTY_CARD_TEXT:
        'You have no in-store sessions scheduled at the moment. Click below to book one now!',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_PATIENT_LABEL: 'Patient',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_DATE_LABEL: 'Date',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_TIME_LABEL: 'Time',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_DOCTOR_LABEL: 'Doctor',
    DASHBOARD_MANAGE_EYE_EXAMS_CARD_LOCATION_LABEL: 'Location',
    DASHBOARD_MY_STORE_CARD_DIRECTIONS_LABEL: 'Get directions',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_LABEL: 'Store hours',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_MON_LABEL: 'Mon',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_TUE_LABEL: 'Tue',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_WED_LABEL: 'Wed',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_THU_LABEL: 'Thu',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_FRI_LABEL: 'Fri',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_SAT_LABEL: 'Sat',
    DASHBOARD_MY_STORE_CARD_STORE_HOURS_SUN_LABEL: 'Sun',
    DASHBOARD_MY_FAVORITES_CARD_FROM_LABEL: 'From',
    DASHBOARD_MY_FAVORITES_CARD_OFF_LABEL: '{DISCOUNT_PERCENTAGE}% Off',
    DASHBOARD_MY_ORDERS_CARD_ORDER_LABEL: 'Order',
    DASHBOARD_MY_ORDERS_CARD_ORDER_ID_LABEL: '#{ORDER_NUMBER}',
    DASHBOARD_MY_ORDERS_CARD_DATE_LABEL: 'Date',
    DASHBOARD_MY_ORDERS_CARD_STATUS_LABEL: 'Status',
    DASHBOARD_MY_ORDERS_CARD_STATUS_PROGRESS_LABEL: 'In progress',
    DASHBOARD_MY_ORDERS_CARD_STATUS_PRESCRIPTION_REQUIRED_LABEL: 'Prescripion required',
    DASHBOARD_MY_ORDERS_CARD_STATUS_PROGRESS_LINK_LABEL: 'Send it now',
    DASHBOARD_MY_ORDERS_CARD_STATUS_COMPLETED_LABEL: 'Completed',
    DASHBOARD_MY_ORDERS_CARD_STATUS_CANCELLED_LABEL: 'Cancelled',
    DASHBOARD_MY_ORDERS_CARD_TOTAL_LABEL: 'Total',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_DATE_LABEL: 'Date',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_TIME_LABEL: 'Time',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_PURPOSE_LABEL: 'Visit purpose',
    DASHBOARD_MY_INSTORE_APPOINTMENT_CARD_LOCATION_LABEL: 'Location',
    DASHBOARD_MY_STORE_INPUT_PLACEHOLDER: 'Enter City / State or Zip Code',
    MY_APPOINTMENTS_EYE_EXAMS_BACK_CTA_LABEL: 'Back',
    MY_APPOINTMENTS_IN_STORE_SERVICES_BACK_CTA_LABEL: 'Back',
    MYPURCHASES_ONLINE_ORDERS_BACK_CTA_LABEL: 'Back',
    IN_STORE_PURCHASES_BACK_CTA_LABEL: 'Back',
    BACK_CTA_LABEL: 'Back',
    MY_PROFILE_PERSONAL_DETAILS_BACK_CTA_LABEL: 'Back',
    SETTINGS_BACK_CTA_LABEL: 'Back',
    INBOX_BACK_CTA_LABEL: 'Back',
    MY_STORES_BACK_CTA_LABEL: 'Back',
    ADDRESSES_BACK_CTA_LABEL: 'Back',
    PAYMENT_METHODS_BACK_CTA_LABEL: 'Back',
    MY_APPOINTMENTS_EYE_EXAMS_FIRST_OVERVIEW_TITLE: 'Book an eye exam',
    MY_APPOINTMENTS_EYE_EXAMS_FIRST_OVERVIEW_MESSAGE:
        "Haven't scheduled an eye exam yet? Book one for you and your family",
    MY_APPOINTMENTS_EYE_EXAMS_FIRST_OVERVIEW_CTA_LABEL: 'Schedule Now',
    MY_APPOINTMENTS_EYE_EXAMS_SECOND_OVERVIEW_TITLE: 'Sync an eye exam',
    MY_APPOINTMENTS_EYE_EXAMS_SECOND_OVERVIEW_MESSAGE:
        'Do you have a current or past booking that you want to sync into your account?',
    MY_APPOINTMENTS_EYE_EXAMS_SECOND_OVERVIEW_CTA_LABEL: 'Sync Now',
    CURRENCY_LABEL: '$',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_RESCHEDULE: 'Reschedule',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_CANCEL_EXAM: 'Cancel exam',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_PATIENT_LABEL: 'Patient:',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_DOCTOR_LABEL: 'Doctor:',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_DOCTOR_INFO_LABEL: 'More info',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_LOCATION_LABEL: 'Location:',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_DIRECTION_LABEL: 'Get directions',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_REMINDER_LABEL_FIRST_PART: 'Take a moment to complete your ',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_REMINDER_LINK_LABEL: 'Eye Exam Form',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_REMINDER_LABEL_SECOND_PART:
        " online and save time at the Doctor's office.",
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_COMPLETED_LABEL_FIRST_PART: 'You have completed your ',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_COMPLETED_LINK_LABEL: 'Eye Exam Form',
    MY_APPOINTMENTS_EYE_EXAMS_UPCOMING_COMPLETED_LABEL_SECOND_PART: '.',
    MYAPPOINTMENTS_EYE_EXAMS_UPCOMING_DATE_LABEL: '{EYE_EXAM_DATE} AT {EYE_EXAM_HOUR}',
    MYAPPOINTMENTS_EYE_EXAMS_PAST_ASC_SORT: 'Newest first',
    MYAPPOINTMENTS_EYE_EXAMS_PAST_DESC_SORT: 'Oldest first',
    EDIT_CTA_LABEL: 'Edit',
    MYAPPOINTMENT_EYE_EXAMS_PAST_LABEL: 'Past eye exams',
    MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_MESSAGE: 'Are you sure you want to cancel?',
    MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CONFIRM_CTA_LABEL: 'YES, cancel',
    MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CANCEL_CTA_LABEL: 'NO, close',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_TITLE: 'Sync my eye exams',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_LONG_SYNC_MODAL_TITLE: 'Almost there!',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_SUBTITLE:
        'To manage upcoming and past exams, please provide the following information.',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_LONG_SYNC_MODAL_SUBTITLE:
        'Please wait a little longer while we process your request...',
    FIELD_CANNOT_BE_EMPTY_MESSAGE: 'The {FORM_FIELD} field cannot be empty',
    MY_APPOINTMENT_EYE_EXAMS_INVALID_DATE_OF_BIRTH:
        'Error message: user needs to be 18 years or older!',
    MY_APPOINTMENT_EYE_EXAMS_INVALID_PHONE_NUMBER: 'Please enter a valid phone number.',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_FIRSTNAME_LABEL: 'first name',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_FIRSTNAME_PLACEHOLDER_LABEL:
        'first name',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_INVALID_FIELD:
        'Please enter letters only',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_LASTNAME_LABEL: 'last name',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_LASTNAME_PLACEHOLDER_LABEL: 'last name',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_DOB_LABEL: 'date of birth',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_DOB_PLACEHOLDER_LABEL: 'date of birth',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_PHONE_LABEL: 'phone number',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_FORM_FIELD_PHONE_PLACEHOLDER_LABEL: 'phone number',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_AGREE_MESSAGE:
        'By clicking SUBMIT, you consent to having information related to previous eye exams displayed in your Target Optical My Account.',
    MYAPPOINTMENT_EYE_EXAMS_OVERVIEW_SYNC_MODAL_GENERIC_ERROR:
        'It looks like there was a problem with the information you entered. Please check it and try again or contact our customer service.',
    MYAPPOINTMENTS_EYE_EXAMS_UPCOMING_STATUS_BOOKED: 'Booked',
    MYAPPOINTMENTS_EYE_EXAMS_UPCOMING_STATUS_CANCELLED: 'Cancelled',
    MYAPPOINTMENTS_EYE_EXAMS_UPCOMING_TOOGLE_LABEL: 'UPCOMING EYE EXAMS',
    MYAPPOINTMENTS_EYE_EXAMS_PAST_TOOGLE_LABEL: 'PAST EYE EXAMS',
    SUBMIT_CTA_LABEL: 'Submit',
    INVALID_DATE_MESSAGE: 'Please enter a valid date of birth',
    MYAPPOINTMENTS_IN_STORE_SERVICES_OVERVIEW_MESSAGE:
        'Quickly book a personalized styling session, free fittings & adjustments and much more.',
    MYAPPOINTMENTS_IN_STORE_SERVICES_OVERVIEW_CTA: 'schedule a STORE SERVICE',
    MYAPPOINTMENTS_IN_STORE_SERVICES_UPCOMING_APPOINTMENTS_LABEL: 'Upcoming appointments',
    MYAPPOINTMENTS_IN_STORE_SERVICES_PAST_APPOINTMENTS_LABEL: 'Past appointments',
    MYAPPOINTMENTS_IN_STORE_SERVICES_RESCHEDULE_CTA_LABEL: 'Reschedule',
    MYAPPOINTMENTS_IN_STORE_SERVICES_CANCEL_APPOINTMENT_CTA_LABEL: 'Cancel Appointment',
    MYAPPOINTMENTS_IN_STORE_SERVICES_APPOINTMENT_VISIT_PURPOS_LABEL: 'Visit purpose',
    MYPURCHASES_ONLINE_ORDERS_PAGE_TOP_LABEL: 'My Orders',
    MYPURCHASES_ONLINE_ORDERS_PAGE_LABEL: 'Order history',
    MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_TITLE: 'Order history',
    MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_FIRST_PART: 'Your order history is empty.',
    MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_SECOND_PART: 'Let’s change that!',
    MYPURCHASES_ONLINE_ORDERS_SHOP_EYEWEAR_CTA_LABEL: 'Shop Eyewear',
    MYPURCHASES_ONLINE_ORDERS_SHOP_CONTACT_LENSES_CTA_LABEL: 'Shop Contacts',
    MYPURCHASES_ONLINE_ORDERS_TOTAL_ORDERS: '({TOTAL_ORDERS} orders)',
    MYPURCHASES_ONLINE_ORDERS_TOTAL_ORDERS_SINGLE_ORDER: '(1 order)',
    MYAPPOINTMENTS_IN_STORE_SERVICES_CREATION_DATE_LABEL: '{IN_STORE_DATE} at {IN_STORE_HOUR}',
    MY_APPOINTMENTS_IN_STORE_SERVICES_LOCATION_LABEL: 'Location',
    MY_APPOINTMENTS_IN_STORE_SERVICES_DIRECTION_LABEL: 'Get directions',
    MYAPPOINTMENTS_EYE_EXAMS_PAGE_TITLE: 'Eye exams',
    MYPURCHASES_ONLINE_ORDERS_TOTAL_FILTERED_ORDERS: '{TOTAL_FILTERED_ORDERS} orders made in',
    MYPURCHASES_ONLINE_ORDERS_TOTAL_FILTERED_ORDER: '1 order made in',
    MYPURCHASES_ONLINE_ORDERS_ORDER_NUMBER: 'Order #{ORDER_NUMBER}',
    MYPURCHASES_ONLINE_ORDERS_VIEW_DETAILS_CTA_LABEL: 'View Details',
    MYPURCHASES_ONLINE_ORDERS_REORDER_CONTACT_LENSES_CTA_LABEL: 'Reorder Contacts',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DATE_LABEL: 'Date',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_LABEL: 'Status',
    MY_PURCHASES_ONLINE_ORDERS_FIRST_SELECT_OPTION: 'Last 6 months',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_LABEL: 'In progress',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_LABEL_DESCRIPTION:
        'Your order is being processed',
    MYPURCHASES_ONLINE_ORDERS_ORDER_EDD_LABEL: 'Estimated delivery date: ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_DIFFERENT_LABEL:
        'The items in this order have different statuses.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_DIFFERENT_2_LABEL:
        'Check order details to learn more about each of them.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_SHIPPED_LABEL: 'Shipped',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_SHIPPED_LABEL_DESCRIPTION: 'Your order has been shipped',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_EXCHANGED_LABEL: 'Exchanged',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_PROVIDED_LABEL: 'Prescription provided',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_REQUIRED_LABEL:
        'We require a prescription to complete processing your order.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_LINK: 'Submit now',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_COMPLETED_LABEL: 'Completed',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_CANCELLED_LABEL: 'Cancelled',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_RETURNED_LABEL: 'Returned',
    MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_RETURNED_LABEL_DESCRIPTION: 'Order returned',
    MYPURCHASES_ONLINE_ORDERS_ORDER_TOTAL_LABEL: 'Total',
    MYPURCHASES_ONLINE_ORDERS_ORDER_COMPLETED_SUGGEST:
        'Issues with your order? Come visit us in store to start the returns procedure ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_COMPLETED_SUGGEST_PLACEHOLDER: 'find a store',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_1_SUGGEST: 'Question on your order? ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER:
        'Contact customer service',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_2_SUGGEST:
        ' to get support or learn more about our ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER_RETURN: 'return policy.',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_1_SUGGEST: 'Question on your order? ',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER: 'Contact your store',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_2_SUGGEST: ' to get support or visit our ',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER_RETURN: 'return policy',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_TOP_SUGGEST:
        'Help us provide you with even better service next time. ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_TOP_PLACEHOLDER: 'Leave us feedback.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAGE_TITLE: 'Order details',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_BACK_CTA_LABEL: 'Go back to order history',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_BACK_CTA_MOBILE_LABEL: 'Back',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_ORDER_NUMBER_LABEL: 'Order number:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_ORDER_DATE_LABEL: 'Order date:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_STATUS_LABEL: 'Status:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_STATUS_PRESCRIPTION: 'In progress',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_STATUS_COMPLETED: 'Completed',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_LINK_LABEL: 'Print a receipt',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_TRACK_YOUR_ORDER_CTA_LABEL: 'Track Your Order',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_REORDER_NOW_CTA_LABEL: 'Reorder Now',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_STATUS_COMPLETED_SUGGEST:
        'Issues with your order? Come visit us in store to start the returns procedure {LINK_PLACEHOLDER}',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_STATUS_COMPLETED_SUGGEST_PLACEHOLDER: 'find a store',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_READY_FOR_PICKUP_TITLE: 'Ready for pick up at',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_READY_FOR_PICKUP_ADDRESS_PLACEHOLDER: 'Get Directions',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_QUOTE_ADDRESS_LABEL: 'Based on your quotation from:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_LABEL: 'Item status:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_NOT_BUYABLE_LABEL:
        'This product is not available for online reorder. Please <a href="/to-us/eye-exams">visit us</a> in person to check for in-store availability.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_SHIPPED_LABEL: 'Shipped',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_DELIVERED_LABEL: 'Delivered',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_EXCHANGED_LABEL: 'Exchanged',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_CANCELLED_LABEL: 'Cancelled',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_RETURNED_LABEL: 'Returned',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_RETURNED_LABEL_DESCRIPTION:
        'Order returned',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TRACK_THIS_ITEM_CTA_LABEL:
        'Track This Item',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_TITLE:
        'In order to process your order, we need your prescription.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_SUBTITLE:
        'Need a new prescription?',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_PLACEHOLDER:
        'Schedule an eye exam',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_SUBMIT_NOW_CTA_LABEL:
        'Submit Now',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_LABEL: 'Frame:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_COLOR_LABEL: 'Frame color:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL: 'Frame size:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL_MOBILE: 'Frame Size:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL_MOBILE_RETAIL:
        'Frame size:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENSES_LABEL: 'Lenses',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_INSURANCE_BENEFITS_LABEL:
        'Insurance benefits:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_LABEL: 'TOTAL:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_CL_LABEL: 'TOTAL ',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_CL_SECOND_LABEL:
        '(###NUM### boxes)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_LABEL: 'EYE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL: 'POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL: 'DIA',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL: 'BC',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL: 'BOXES',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_SPHERE_LABEL: 'POWER/  SPHERE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL: 'CYL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL: 'AXIS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL: 'COLOR',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL: 'ADD',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL: 'DOM',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_RIGHT_LABEL: 'Right',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_LEFT_LABEL: 'Left',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL: 'OD (right)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL: 'OS (left)',
    RESPONSIBLE_SHIPPING_LABEL: 'Responsible shipping',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_OVERVIEW_TITLE:
        'Shipping and Payment details',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SHIPPING_METHOD: 'Shipping method:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SHIPPING_ADDRESS: 'Shipping address:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_RECIPIENT_DETAILS:
        'Recipient’s details:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_BILLING_ADDRESS: 'Billing address:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_PAYMENT_METHOD: 'Payment method:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SUBTOTAL: 'Subtotal (excl. tax):',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_SHIPPING_COST: 'Shipping cost:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_TAXES: 'Taxes:',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_ORDER_TOTAL: 'Order Total:',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_ORDER_RECEIVE:
        'We received your order! Thank you for shopping at Target Optical! Our team is reviewing your order.',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_IN_PROCESS: 'Your order is being proccessed',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED: 'Your order has been shipped',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_READY_FOR_PICKUP: 'Your order is ready for pickup',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_DISPENSED: 'Completed',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_PLEASE_CALL_THE_STORE:
        'Important order update! Please call the store ${storePhoneNumber}',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_DELIVERED: 'Delivered',
    MYPURCHASES_ONLINE_ORDERS_PAGE_LABEL_BUTTON_ONLINE: 'ONLINE',
    MYPURCHASES_RETAIL_ORDERS_PAGE_LABEL_BUTTON_IN_STORE: 'IN STORE',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_RETURNED: 'Order returned',
    MYPURCHASES_RETAIL_ORDERS_ORDER_STORE_LABEL: 'Store',
    MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_EYEWEAR: 'Eyewear',
    MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_CONTACT: 'Contact lenses',
    MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT: 'Purchased in store',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_OVERVIEW_TITLE: 'Payment details',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_RIGHT_LABEL:
        'OD (Right)',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_LEFT_LABEL: 'OD (Left)',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_WARRANTY:
        'Worry free protection plan',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_ONLY: 'LENS ONLY',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_VISION_NEED: 'Vision need:',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_BRAND: 'Lens brand:',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_TYPE: 'Lens type:',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_THICKNESS: 'Lens thickness:',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FINISHINGS: 'Finishings:',
    MYPURCHASES_SYNC_YOUR_PURCHASES_TITLE: 'Sync your purchases',
    MYPURCHASES_SYNC_YOUR_PURCHASES_INSTRUCTION:
        'Provide a receipt number, date of birth and last name to view your purchase history.',
    MYPURCHASES_SYNC_YOUR_PURCHASES_INSTRUCTION_LINK: 'Where is my receipt number?',
    MYPURCHASES_SYNC_YOUR_PURCHASES_ERROR_MESSAGE_EMPTY_FIELD: 'This field is required',
    MYPURCHASES_SYNC_YOUR_PURCHASES_RECEIPT_NUMBER_LABEL: 'Receipt number',
    MYPURCHASES_SYNC_YOUR_PURCHASES_LASTNAME_LABEL: 'Last name',
    MYPURCHASES_SYNC_YOUR_PURCHASES_BIRTHDATE_LABEL: 'Date of birth',
    MYPURCHASES_SYNC_YOUR_PURCHASES_INVALID_DATE_MESSAGE: 'Invalid date',
    MYPURCHASES_SYNC_YOUR_PURCHASES_AGREEMENT_MESSAGE:
        'I agree that purchase history information can be displayed in my LensCrafters myAccount.',
    MYPURCHASES_SYNC_YOUR_PURCHASES_CONTACT_US_MESSAGE: "Can't find your receipt?",
    MYPURCHASES_SYNC_YOUR_PURCHASES_CONTACT_US_LINK: 'Contact us',
    MYPURCHASES_SYNC_YOUR_PURCHASES_SYNC_NOW_CTA_LABEL: 'Sync Now',
    MYPURCHASES_SYNC_YOUR_PURCHASES_ERROR_MESSAGE_TITLE: 'We’re sorry, we didn’t find your record.',
    MYPURCHASES_SYNC_YOUR_PURCHASES_ERROR_MESSAGE_FIRST_EXPLANATION:
        'Double-check that the information below matches what was on file at the time of purchase.',
    MYPURCHASES_SYNC_YOUR_PURCHASES_ERROR_MESSAGE_SECOND_EXPLANATION:
        'You have 4 more opportunities to try again.If you need help, please call us at. 1-877-7-LENSCRAFTERS or stop by your local LensCrafters store.',
    MYPURCHASES_SYNC_YOUR_PURCHASES_MODAL_TITLE: 'Finding your receipt number',
    MYPURCHASES_SYNC_YOUR_PURCHASES_MODAL_FIRST_CONTENT_TITLE: 'Full page receipt',
    MYPURCHASES_SYNC_YOUR_PURCHASES_MODAL_FIRST_CONTENT_EXPLANATION:
        'Your receipt number is shown at the top right of the page under the bar code.',
    IMAGE_NON_AVAILABLE_LABEL: 'Image non available',
    MYPURCHASES_SYNC_YOUT_PURCHASES_MODAL_IMAGE_NON_AVAILABLE_MESSAGE: 'Image non available',
    MYPURCHASES_SYNC_YOUR_PURCHASES_MODAL_SECOND_CONTENT_TITLE: 'Till receipt',
    MYPURCHASES_SYNC_YOUR_PURCHASES_MODAL_SECOND_CONTENT_EXPLANATION:
        'Your receipt number is shown at the very bottom of the receipt under the bar code.',
    IN_STORE_PURCHASES_PAGE_TITLE: 'In-store purchase',
    IN_STORE_PURCHASES_MY_PURCHASES_TITLE: 'Your purchases',
    IN_STORE_PURCHASES_MY_PURCHASES_STORE_LABEL: 'PURCHASED FROM',
    IN_STORE_PURCHASES_MY_PURCHASES_LENSES_LABEL: 'Your lenses',
    IN_STORE_PURCHASES_MY_PURCHASES_EYEWEAR_PROTECTION_PLAN_LABEL: 'Eyewear protection plan',
    IN_STORE_PURCHASES_MY_PURCHASES_TOTAL: 'TOTAL',
    MYPROFILE_PERSONAL_DETAILS_TITLE: 'Personal details',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_FULL_NAME: 'FULL NAME',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_CANNOT_BE_EMPTY_MESSAGE:
        'The {FORM_FIELD} field cannot be empty',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_SHIPPINGFIRSTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_SHIPPINGLASTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_BILLINGFIRSTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_BILLINGLASTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_FIRSTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_FIELD_INVALID_LASTNAME: 'Please enter letters only',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGFIRSTNAME_LABEL: 'first name',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGLASTNAME_LABEL: 'last name',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_BILLING_ADDRESS: 'BILLING ADDRESS',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_BILLING_ADDRESS_LINE: 'Address line {LINE_NUMBER}',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGADDRESSLINE1_LABEL: 'address line',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_BILLING_ADD_SECOND_ADDRESS_CTA:
        'Add C/O, Apartment, Floor',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGZIPCODE_OTHER_COUNTRIES_LABEL: 'ZIP Code',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGZIPCODE_CA_LABEL: 'Postal Code',
    MYPROFILE_PERSONAL_DETAILS_FORM_BILLINGCITY_LABEL: 'city',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_BILLING_STATE_LABEL: 'state',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_BILLING_PROVINCES_LABEL: 'provinces',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIPPING_ADDRESS: 'SHIPPING ADDRESS',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIP_TO_BILLING_ADDRESS: 'Ship to billing address',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIP_TO_ANOTHER_ADDRESS: 'Ship to another address',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGFIRSTNAME_LABEL: 'first name',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGLASTNAME_LABEL: 'last name',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGADDRESSLINE1_LABEL: 'address line',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIPPING_ADDRESS_LINE: 'Address line {LINE_NUMBER}',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIPPING_ADD_SECOND_ADDRESS_CTA:
        'Add C/O, Apartment, Floor',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGZIPCODE_OTHER_COUNTRIES_LABEL: 'ZIP Code',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGPOSTALCODE_CA_LABEL: 'Postal Code',
    MYPROFILE_PERSONAL_DETAILS_FORM_SHIPPINGCITY_LABEL: 'city',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIPPING_STATE_LABEL: 'state',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SHIPPING_PROVINCES_LABEL: 'provinces',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SAVE_CHANGES_CTA: 'save changes',
    MYPROFILE_PERSONAL_DETAILS_PRIMARY_FORM_SUCCESS_MESSAGE: 'All changes are saved',
    MYPROFILE_PERSONAL_DETAILS_FORM_EMAIL_LABEL: 'e-mail',
    MYPROFILE_PERSONAL_DETAILS_FORM_PHONENUMBER1_LABEL: 'phone number',
    MYPROFILE_PERSONAL_DETAILS_FORM_INVALID_PHONENUMBER1: 'Please enter a valid phone number.',
    MYPROFILE_PERSONAL_DETAILS_FORM_INVALID_PHONENUMBER2: 'Please enter a valid phone number.',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_SECOND_PHONE_NUMBER_LABEL: 'Secondary Phone number',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_EMAIL: 'E-MAIL',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_PHONE_NUMBER: 'PHONE NUMBER',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_FIELD_CANNOT_BE_EMPTY_MESSAGE:
        'The {FORM_FIELD} field cannot be empty',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_ADD_SECONDARY_LINK: 'Add secondary',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_DEFAULT_PHONE_NUMBER_LABEL: 'Default phone number',
    MYPROFILE_PERSONAL_DETAILS_SECONDARY_FORM_SET_AS_DEFAULT: 'Set as default',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_BIRTHDATE_LABEL: 'date of birth',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_INVALID_DATE_MESSAGE: 'Invalid date',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_BIRTHDATE: 'DATE OF BIRTH',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_GENDER: 'GENDER',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_MALE: 'Male',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_FEMALE: 'Female',
    MYPROFILE_PERSONAL_DETAILS_THIRD_FORM_OTHER: 'Prefer not to say',
    MYPROFILE_PERSONAL_DETAILS_INVALID_EMAIL_MESSAGE: 'Please enter a valid email address',
    MYPROFILE_PERSONAL_DETAILS_INVALID_SHIPPING_ZIP_CODE_MESSAGE: 'Please enter a valid zip code.',
    MYPROFILE_PERSONAL_DETAILS_INVALID_SHIPPING_POSTAL_CODE_MESSAGE:
        'Please enter a valid postal code.',
    MYPROFILE_PERSONAL_DETAILS_INVALID_BILLING_ZIP_CODE_MESSAGE: 'Please enter a valid zip code.',
    MYPROFILE_PERSONAL_DETAILS_INVALID_BILLING_POSTAL_CODE_MESSAGE:
        'Please enter a valid postal code.',
    MYPROFILE_PERSONAL_DETAILS_INVALID_DATE_OF_BIRTH_MESSAGE:
        'You must be at least 18 years of age to have an account.',
    MYPROFILE_PERSONAL_DETAILS_INVALID_DATE_MESSAGE: 'Please enter a valid date of birth',
    SETTINGS_PAGE_TITLE: 'My Settings',
    INBOX_PAGE_TITLE: 'My Inbox',
    INBOX_PAGE_TITLE_INSIDE: 'Communications',
    SETTINGS_PERSONAL_INFORMATION_TITLE: 'Personal information',

    SETTINGS_INFORMATION_MESSAGE:
        'Update your password, change your communication preferences, and check any personalization items that apply to you so we can better serve your needs.',
    SETTINGS_UPDATE_PASSWORD: 'Update password',
    SETTINGS_UPDATE_PASSWORD_CURRENTPASSWORD_EMPTY_FIELD_MESSAGE: 'This field cannot be empty',
    SETTINGS_UPDATE_PASSWORD_NEWPASSWORD_EMPTY_FIELD_MESSAGE: 'This field cannot be empty',
    SETTINGS_UPDATE_PASSWORD_NEWPASSWORDCONFIRMED_EMPTY_FIELD_MESSAGE: 'This field cannot be empty',
    SETTINGS_UPDATE_PASSWORD_CURRENT_PASSWORD_FIELD_LABEL: 'Current password',
    SETTINGS_UPDATE_PASSWORD_CURRENT_PASSWORD_INFORMATION_MESSAGE:
        'The password must contain at least:',
    SETTINGS_UPDATE_PASSWORD_MINIMUM_REQUIREMENTS_ERROR_MESSAGE:
        'Password does not meet minimum requirements.',
    SETTINGS_UPDATE_PASSWORD_INVALID_ERROR_MESSAGE: 'The password you entered do not match',
    SETTINGS_UPDATE_PASSWORD_INVALID_CURRENT_PASSWORD:
        'The password you entered does not match the current one associated with your account.',
    PASSWORD_CHECKLIST_MIN_LENGTH_RULE_MESSAGE: '8 characters',
    PASSWORD_CHECKLIST_CAPITAL_RULE_MESSAGE: '1 uppercase letter (A-Z)',
    PASSWORD_CHECKLIST_LOWER_RULE_MESSAGE: '1 lowercase letter (a-z)',
    PASSWORD_CHECKLIST_NUMBER_RULE_MESSAGE: '1 number (0-9)',
    PASSWORD_CHECKLIST_SPECIAL_CHAR_RULE_MESSAGE: '1 special character (!£#)',
    SETTINGS_UPDATE_PASSWORD_NEW_PASSWORD_CONFIRMED: 'Confirm your password',
    SETTINGS_UPDATE_PASSWORD_NEW_PASSWORD: 'New password',
    SETTINGS_UPDATE_PASSWORD_SAVE_CHANGES_CTA: 'save changes',
    SETTINGS_UPDATE_PASSWORD_FORM_SUCCESS_MESSAGE: 'All changes are saved',
    SETTINGS_UPDATE_PASSWORD_INVALID_PASSWORD: 'The password must satisfies all rules',
    SETTINGS_SUBSCRIPTION_TITLE: 'SUBSCRIPTION',
    SETTINGS_SUBSCRIPTION_SUBTITLE: 'You are currently subscribed with the following e-mail:',
    SETTINGS_SUBSCRIBE_CTA: 'subscribe',
    SETTINGS_UNSUBSCRIBE_CTA: 'unsubscribe',
    SETTINGS_SUBSCRIPTION_FEEDBACK:
        'You are not subscribed to receive news and offers by text message. ',
    SETTINGS_ADD_PHONE_NUMBER_LINK: 'Add phone number',
    SETTINGS_ADD_EMAIL_ADDRESS: 'Add e-mail address',
    SETTINGS_EMAIL_ADDRESS_INPUT_LABEL: 'E-mail address',
    SETTINGS_EMAIL_ADDRESS_INPUT_SUGGESTION:
        'By subscribing, you certify that you are 18 years or older.',
    SETTINGS_NOT_EMAIL_SUBSCRIPTION_MESSAGE:
        'You are not subscribed to receive news and offers by e-mail.',
    SETTINGS_TERMS_AND_PRIVACY_STOP_PLACEHOLDER: 'STOP',
    SETTINGS_TERMS_AND_PRIVACY_HELP_PLACEHOLDER: 'HELP',
    SETTINGS_TERMS_PLACEHOLDER: 'Terms',
    SETTINGS_PRIVACY_PLACEHOLDER: 'Privacy',
    SETTINGS_TERMS_AND_PRIVACY_FIRST_PART:
        'I would like to receive texts from LensCrafters (Yes, I agree to these terms).',
    SETTINGS_TERMS_AND_PRIVACY_SECOND_PART:
        'By checking this box, I provide my signature consenting to receive recurring automated promotional and personalized marketing text messages from LensCrafters at the cell number used when signing up. Consent is not a condition of any purchase. Reply {HELP_PLACEHOLDER} for help and {STOP_PLACEHOLDER} to cancel. Msg frequency varies. Msg & data rates may apply. View {TERMS_PLACEHOLDER} & {PRIVACY_PLACEHOLDER}',
    SETTINGS_PERSONALIZATION_SETTINGS_TITLE:
        'Answer these questions to help us customize your experience',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_FORM_TITLE: 'Style preferences',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_FORM_TITLE: 'What are your favorite brand(s)?',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_FORM_TITLE: 'What is your favorite eyewear shape?',
    SETTINGS_VISION_CARE_PERSONALIZATION_SETTINGS_FORM_TITLE:
        'What is your preferred type of vision care?',
    SETTINGS_WHO_PERSONALIZATION_SETTINGS_FORM_TITLE: 'Who is this vision care for?',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_WOMEN: 'Women styles',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_MEN: 'Men styles',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_CHILDREN: 'Children styles',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_CONTACT_LENSES: 'Contact lenses',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_MULTI_LENSES: 'Multi focal / Progressive lenses',
    SETTINGS_STYLE_PERSONALIZATION_SETTINGS_BLUE_LIGHT: 'Blue Light',
    SETTINGS_PERSONALIZATION_SETTINGS_FORM_PROCEED_CTA: 'proceed',
    SETTINGS_PERSONALIZATION_SETTINGS_FORM_SAVE_CHANGES_CTA: 'confirm',
    SETTINGS_PERSONALIZATION_SETTINGS_FORM_SKIP_QUESTION_CTA: 'skip this question',
    SETTINGS_PERSONALIZATION_SETTINGS_FORM_BACK_QUESTION_CTA: 'Back to previous question',
    SETTINGS_PERSONALIZATION_SETTINGS_FORM_SUCCESS_MESSAGE: 'All changes are saved',

    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_RAYBAN: 'Ray-Ban',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ARMANI: 'Armani Exchange',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_COACH: 'Coach',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_VOGUE_EYEWEAR: 'Vogue Eyewear',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_OAKLEY: 'Oakley',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_RALPH: 'Ralph',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ARNETTE: 'Arnette',
    SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ANEWDAY: 'A New Day',

    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_RECTANGLE: 'Rectangle',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_CATEYE: 'Cat eye',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_OVAL: 'Oval',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_SQUARE: 'Square',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_ROUND: 'Round',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_PILOT: 'Pilot',
    SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_GEOMETRIC: 'Geometric',

    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_SUN: 'Sun',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_FRAMES: 'Frames / Single vision',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_CONTACTLENSES: 'Contact lenses',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_CHILDRENSTYLE: "Children's style",
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_PRESCRIPTION:
        'Multifocal/progressive prescription',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_BLUELIGHT: 'Blue Light',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_TRANSITION: 'Transition',

    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_JUSTME: 'Just me',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_MYPARTNER: 'My partner',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_ONECHILD:
        'At least 1 child in the household under 12',
    SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_TEEN: 'At least one teenager (12-18 years old)',

    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_FORM_TITLE:
        'Which of the following best describes you?',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_JEWELERY:
        'Glasses can be a fashion accessory, like a watch or the right jewelry.',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_HOW_MUCH:
        'I try to find glasses that are durable and last a long time.',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_LOOK:
        'I care more about how my glasses feel than how they look.',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_YEARLY_EXAM:
        'I have an eye exam every year whether my vision has noticeably changed or not.',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_PARTECIPATE_ACTIVITIES:
        "I need vision correction that won't interfere with my performance in sports or other activities; in fact, I prefer if it enhances them.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SAME_STYLE:
        "I've been wearing the same style of glasses for years.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SHOP_ALONE:
        "I'd rather shop for eyewear alone than be helped by someone in the store.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_EXPRESSION:
        'My eyewear should express me and my personality.',
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_NEED_HELP:
        "I often feel like I don't know what eyewear looks good on me.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_LARGE_FACE:
        "I'm hard to fit because I have a large face.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SMALL_FACE:
        "I'm hard to fit because I have a petite face.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_NARROW_NOSE:
        "I'm hard to fit because I have a narrow nose bridge.",
    SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_WIDE_NOSE:
        "I'm hard to fit because I have a wide nose bridge.",
    SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_JUST_ME: 'Just me',
    SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_MY_PARTNER: 'My Partner',
    SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_UNDER_TWELVE:
        'At least 1 child in the household under 12',
    SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_TWELVE_TO_EIGHTEEN:
        'At least 1 teenager (12-18 years)',
    SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_FORM_TITLE: 'Who else needs vision care?',
    MAX_ANSWER_LABEL: '(Max 3 answers)',
    MY_STORES_PAGE_TITLE: 'My stores',
    MY_STORES_QUICK_SEARCH_TITLE: 'FIND A STORE',
    MY_STORES_QUICK_SEARCH_INFORMATION_MESSAGE:
        'Locate stores near you and save your favorites for easy access to directions, contact info, and more.',
    MY_STORES_QUICK_SEARCH_COMPONENT_PLACEHOLDER: 'Enter City / State or Zip Code',
    MY_STORES_QUICK_SEARCH_COMPONENT_CTA: 'search',
    MY_STORES_FAVOURITES_STORES_LIST_TITLE:
        'Update your prefered store, or add additional stores below.',
    MY_STORES_PHYSICAL_STORE_TITLE: 'MY DEFAULT STORE',
    MY_STORES_SET_AS_DEFAULT_STORE: 'SET AS DEFAULT STORE',
    MY_STORES_PHYSICAL_STORE_REMOVE_CTA: 'remove',
    MY_STORES_PHYSICAL_STORE_ADDRESS_LABEL: 'ADDRESS',
    MY_STORES_PHYSICAL_STORE_DIRECTION_LABEL: 'Get direction',
    MY_STORES_PHYSICAL_STORE_HOURS_LABEL: 'STORE HOURS',
    MY_STORES_PHYSICAL_STORE_MON_LABEL: 'Mon',
    MY_STORES_PHYSICAL_STORE_TUE_LABEL: 'Tue',
    MY_STORES_PHYSICAL_STORE_WED_LABEL: 'Wed',
    MY_STORES_PHYSICAL_STORE_THU_LABEL: 'Thu',
    MY_STORES_PHYSICAL_STORE_FRI_LABEL: 'Fri',
    MY_STORES_PHYSICAL_STORE_SAT_LABEL: 'Sat',
    MY_STORES_PHYSICAL_STORE_SUN_LABEL: 'Sun',
    MY_STORES_PHYSICAL_STORE_SCHEDULE_EYE_EXAM_CTA: 'SCHEDULE EYE EXAM',
    MY_STORES_PHYSICAL_STORE_OTHER_SERVICES_CTA: 'OTHER SERVICES',
    ADDRESSES_TITLE: 'My Addresses',
    ADDRESSES_SUBTITLE: 'Save your address information for easy access and stress-free shipping.',
    ADDRESSES_ADDRESS_FORM_TITLE: 'Shipping address',
    ADDRESSES_ADDRESS_FORM_BILLING_TITLE: 'Billing address',
    ADDRESSES_ADDRESS_FORM_FIELD_CANNOT_BE_EMPTY_MESSAGE: 'The {FORM_FIELD} field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_FIRSTNAME: 'Please enter letters only',
    ADDRESSES_ADDRESS_FORM_INVALID_LASTNAME: 'Please enter letters only',
    ADDRESSES_ADDRESS_FORM_INVALID_ADDRESS1: 'The address line 1 field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_CITY: 'The city field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_BILLINGFIRSTNAME: 'Please enter letters only',
    ADDRESSES_ADDRESS_FORM_INVALID_BILLINGLASTNAME: 'Please enter letters only',
    ADDRESSES_ADDRESS_FORM_INVALID_BILLINGADDRESS1: 'The address line 1 field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_ADDRESS: 'The billing address field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_BILLINGCITY: 'The city field cannot be empty',
    ADDRESSES_ADDRESS_FORM_INVALID_PHONENUMBER: 'Please enter a valid phone number',
    ADDRESSES_ADDRESS_FORM_FIRSTNAME_LABEL: 'first name',
    ADDRESSES_ADDRESS_FORM_FIRSTNAME_LABEL_REQUIRED: 'first name*',
    ADDRESSES_ADDRESS_FORM_LASTNAME_LABEL: 'last name',
    ADDRESSES_ADDRESS_FORM_LASTNAME_LABEL_REQUIRED: 'last name*',
    ADDRESSES_ADDRESS_FORM_PHONENUMBER_LABEL: 'phone number',
    ADDRESSES_ADDRESS_FORM_PHONENUMBER_LABEL_REQUIRED: 'phone number*',
    ADDRESSES_ADDRESS_FORM_PHONENUMBER_USE_DEFAULT_CHECKBOX:
        'Use the phone number already associated with this account',
    ADDRESSES_ADDRESS_FORM_EMAIL_LABEL: 'billing e-mail address',
    ADDRESSES_ADDRESS_FORM_BILLINGADDRESS1_LABEL: 'billing address line 1',
    ADDRESSES_ADDRESS_FORM_BILLINGADDRESS1_LABEL_REQUIRED: 'billing address line 1*',
    ADDRESSES_ADDRESS_FORM_ADDRESS1_LABEL: 'address line 1',
    ADDRESSES_ADDRESS_FORM_ADDRESS1_LABEL_REQUIRED: 'address line 1*',
    ADDRESSES_ADDRESS_FORM_ADDRESS1_HELPER_TEXT: 'We cannot deliver to PO boxes at this time.',
    ADDRESSES_ADDRESS_FORM_ADDRESS2_LABEL: 'Apt / Suite / etc',
    ADDRESSES_ADDRESS_FORM_ADDRESS2_HELPER_TEXT: 'This field is optional.',
    ADDRESSES_ADDRESS_FORM_SHOW_ADDRESS2_LABEL: 'Add C/O, Apartment, Floor',
    ADDRESSES_ADDRESS_FORM_ADDRESS_USE_BILLING_LABEL: 'Use as Billing Address',
    ADDRESSES_ADDRESS_FORM_ADDRESS_USE_DEFAULT_LABEL: 'Set as default address',
    ADDRESSES_ADDRESS_FORM_ZIPCODE_LABEL: 'ZIP code',
    ADDRESSES_ADDRESS_FORM_ZIPCODE_LABEL_REQUIRED: 'ZIP code*',
    ADDRESSES_ADDRESS_FORM_BILLINGZIPCODE_LABEL: 'ZIP code',
    ADDRESSES_ADDRESS_FORM_BILLINGZIPCODE_LABEL_REQUIRED: 'ZIP code*',
    ADDRESSES_ADDRESS_FORM_ZIPCODE_CA_LABEL: 'Postal code',
    ADDRESSES_ADDRESS_FORM_CITY_LABEL: 'city',
    ADDRESSES_ADDRESS_FORM_CITY_LABEL_REQUIRED: 'city*',
    ADDRESSES_ADDRESS_FORM_BILLINGCITY_LABEL: 'city',
    ADDRESSES_ADDRESS_FORM_BILLINGCITY_LABEL_REQUIRED: 'city*',
    ADDRESSES_ADDRESS_FORM_STATE_LABEL: 'state',
    ADDRESSES_ADDRESS_FORM_STATE_LABEL_REQUIRED: 'state*',
    ADDRESSES_ADDRESS_FORM_BILLINGSTATE_LABEL: 'state',
    ADDRESSES_ADDRESS_FORM_BILLINGSTATE_LABEL_REQUIRED: 'state*',
    ADDRESSES_ADDRESS_FORM_COUNTRY_LABEL: 'country',
    ADDRESSES_ADDRESS_FORM_SUBMIT_CTA_LABEL: 'Save Changes',
    ADDRESSES_ADDRESS_FORM_ZIP_CODE_ERROR_MESSAGE: 'Please enter a valid zip code',
    ADDRESSES_ADDRESS_FORM_POSTAL_CODE_ERROR_MESSAGE: 'Please enter a valid postal code',

    PAYMENT_METHODS_TITLE: 'Payment methods',
    PAYMENT_METHODS_CREDIT_CARD_FORM_TITLE: 'Card detail',
    PAYMENT_METHODS_CREDIT_CARD_FORM_FIELD_CANNOT_BE_EMPTY_MESSAGE:
        'The {FORM_FIELD} field cannot be empty',
    PAYMENT_METHODS_CREDIT_CARD_FORM_INVALID_FIRSTNAME: 'Please enter letters only',
    PAYMENT_METHODS_CREDIT_CARD_FORM_INVALID_LASTNAME: 'Please enter letters only',
    PAYMENT_METHODS_CREDIT_CARD_FORM_FIRSTNAME_LABEL: 'first name',
    PAYMENT_METHODS_CREDIT_CARD_FORM_FIRSTNAME_FIELD_LABEL: 'first name*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_NAME_AS_SHOWN: 'Exactly as shown in your card',
    PAYMENT_METHODS_CREDIT_CARD_FORM_LASTNAME_LABEL: 'last name',
    PAYMENT_METHODS_CREDIT_CARD_FORM_LASTNAME_FIELD_LABEL: 'last name*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CREDITCARDNUMBER_LABEL: 'card number',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CREDITCARDNUMBER_FIELD_LABEL: 'card number*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_EXPIRATIONDATE_LABEL: 'expiration date',
    PAYMENT_METHODS_CREDIT_CARD_FORM_EXPIRATIONDATE_FIELD_LABEL: 'expiration date*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CVV_LABEL: 'CVV',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CVV_FIELD_LABEL: 'CVV*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_EMAIL_LABEL: 'e-mail address',
    PAYMENT_METHODS_CREDIT_CARD_FORM_EMAIL_FIELD_LABEL: 'billing e-mail address*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ADDRESS_LABEL: 'billing address',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ADDRESS_FIELD_LABEL: 'billing address*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ZIPCODE_LABEL: 'ZIP code',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ZIPCODE_FIELD_LABEL: 'ZIP code*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ZIPCODE_CA_LABEL: 'Postal code',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ZIPCODE_CA_FIELD_LABEL: 'Postal code*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CITY_LABEL: 'billing city',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CITY_FIELD_LABEL: 'billing city*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_STATE_LABEL: 'billing state',
    PAYMENT_METHODS_CREDIT_CARD_FORM_STATE_FIELD_LABEL: 'billing state*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_COUNTRY_LABEL: 'billing country',
    PAYMENT_METHODS_CREDIT_CARD_FORM_COUNTRY_FIELD_LABEL: 'billing country*',
    PAYMENT_METHODS_CREDIT_CARD_FORM_INVALID_DATE_MESSAGE: 'This credit card has expired.',
    PAYMENT_METHODS_CREDIT_CARD_FORM_INVALID_DATE: 'Invalid date',
    PAYMENT_METHODS_CREDIT_CARD_FORM_SUBMIT_CTA_LABEL: 'Add Payment Method',
    PAYMENT_METHODS_CREDIT_CARD_EDIT_FORM_SUBMIT_CTA_LABEL: 'Save Changes',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ERROR_MESSAGE:
        'It looks like there was a problem with adding your card. Please check it and try again or contact our customer service.',
    PAYMENT_METHODS_CREDIT_CARD_NUMBER_ERROR_MESSAGE:
        'Your credit card information does not match a valid credit card.',
    PAYMENT_METHODS_CREDIT_CARD_FORM_INVALID_EMAIL_MESSAGE: 'Please enter a valid email address',
    PAYMENT_METHODS_ADD_CTA_LABEL: 'Add New Payment Method',
    PAYMENT_METHOD_DETAIL_TITLE: 'Credit card',
    PAYMENT_METHOD_DETAIL_EDIT_CTA_LABEL: 'Edit',
    PAYMENT_METHOD_DETAIL_REMOVE_CTA_LABEL: 'Remove',
    PAYMENT_METHOD_DETAILS_LAST_FOUR_DIGITS_MESSAGE: 'ends with **{LAST_FOUR_DIGITS}',
    PAYMENT_METHOD_DETAILS_EXPIRED_MESSAGE: 'Oops! It looks like this card has expired.',
    PAYMENT_METHOD_DETAILS_EXPIRATION_DATE_MESSAGE: 'Expires in {EXPIRATION_DATE}',
    PAYMENT_METHOD_DETAILS_DEFAULT_MESSAGE: 'Default payment method',
    PAYMENT_METHOD_DETAILS_SET_AS_DEFAULT_MESSAGE: 'Set as default',
    PAYMENT_METHOD_DELETE_MODAL_TITLE: 'Are you sure you want to remove this payment method?',
    PAYMENT_METHOD_DELETE_MODAL_REMOVE_CTA_LABEL: 'yes, remove',
    PAYMENT_METHOD_DELETE_MODAL_CLOSE_CTA_LABEL: 'no, close',
    PAYMENT_METHODS_CREDIT_CARD_FORM_CVV_ERROR: 'Please enter a valid security code',
    PAYMENT_METHODS_CREDIT_CARD_FORM_ZIP_CODE_ERROR_MESSAGE: 'Please enter a valid zip code',
    PAYMENT_METHODS_CREDIT_CARD_FORM_POSTAL_CODE_ERROR_MESSAGE: 'Please enter a valid postal code',
    PURCHASES_MY_ADDRESSES_MENU_LABEL: 'My Addresses',
    VISION_CARE_MENU_LABEL: 'My Vision benefits',
    VISION_CARE_MENU_SUBTITLE_LABEL: 'Sync insurance & review benefits',
    INBOX_EMAIL_TITLE_LABEL: 'E-mail',
    INBOX_EMAIL_SUBTITLE_LABEL: 'Check the box to receive news and offers via e-mail.',
    INBOX_CHECKBOX_EMAIL_TITLE_LABEL: 'Send me promotions and offers by email.',
    INBOX_CHECKBOX_EMAIL_SUBTITLE_LABEL:
        'Sign up to receive news and exclusive offers from TargetOptical.com.<br> You can withdraw consent at any time. For more details see our <a class="bold" href="/to-us/privacy-policy">Privacy Policy</a>.<br> I certify that I am 13 years or older.',
    INBOX_PHONE_NUMBER_TITLE_LABEL: 'Phone number',
    INBOX_PHONE_NUMBER_SUBTITLE_LABEL: 'Check the box to receive news and offers via phone number.',
    INBOX_CHECKBOX_PHONE_NUMBER_TITLE_LABEL:
        'I would like to receive texts from Target Optical (Yes, I agree to these terms).',
    INBOX_CHECKBOX_PHONE_NUMBER_SUBTITLE_LABEL:
        'By checking this box, I provide my signature consenting to receive recurring automated promotional and personalized marketing text <br> messages from Target Optical at the cell number used when signing up. Consent is not a condition of any purchase.<br> Reply <span class="bold">HELP</span> for help and <span class="bold">STOP</span> to cancel. Msg frequency varies. Msg &amp; data rates may apply. View <a class="bold" href="/to-us/terms-and-conditions">Terms</a> &amp; <a class="bold" href="/to-us/privacy-policy">Privacy</a>.',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_TITLE:
        'Prescription submitted',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_SUBTITLE:
        'We’ll do the rest',
    MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_TITLE:
        'Prescription received in store.',
    MYPURCHASES__RETAIL_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_SUBTITLE:
        'You’re all set!',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_PREVIEW: 'Preview',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRICE_BOX_LEFT_LABEL: 'Price per box',
    MANUAL_TABLE_VPRISM_LABEL: 'Vertical Prism (&Delta;)',
    YOUR_PRESCRIPTION_LABEL: 'Your prescription',
    YOUR_PRESCRIPTION_ERROR_LABEL: 'Preview is not available for this format',
    PRESCRIPTION_STEP2_DOCTOR_TITLE_LABEL: "We'll call your doctor",
    PRESCRIPTION_MODAL_TITLE: 'Your prescription details',
    PRESCRIPTION_MODAL_LABEL: 'Prescription',
    DOCTOR_TABLE_DOCTOR_NAME_LABEL: 'Doctor name',
    DOCTOR_TABLE_CLINIC_NAME_LABEL: 'Clinic name',
    DOCTOR_TABLE_ADDRESS_LABEL: 'Address',
    MANUAL_TABLE_SPH_LABEL: 'SPH',
    MANUAL_TABLE_CYL_LABEL: 'CYL',
    MANUAL_TABLE_AXIS_LABEL: 'AXIS',
    MANUAL_TABLE_ADD_LABEL: 'ADD',
    MANUAL_TABLE_PD_LABEL: 'PD',
    MANUAL_TABLE_OD_LABEL: 'OD',
    MANUAL_TABLE_OS_LABEL: 'OS',
    MANUAL_TABLE_VPRISM_BASE_LABEL: 'Base Direction',
    MANUAL_TABLE_HPRISM_BASE_LABEL: 'Base Direction',
    ADD_CREDITCARD_NAME: 'The cardholder name field cannot be empty.',
    MY_SETTINGS_PERSONALIZATION_ERROR: 'Please select at least one of the options above',
    INBOX_REMOVE_SUCCESS_MESSAGE: 'You will no longer receive news and offers via e-mail.',
    MY_PRESCRIPTIONS_MENU_LABEL: 'My Prescriptions',
    MYAPPOINTMENTS_MY_PRESCRIPTIONS_PAGE_TITLE: 'My prescriptions',
    MY_APPOINTMENTS_MY_PRESCRIPTIONS_BACK_CTA_LABEL: 'Back',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_1_BRAND_SUBTITLE: 'Select your brand',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_1_BRAND_EDIT_SUBTITLE:
        'Select your brand of contact lenses',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_2_ENTER_PRESCRIPTION_SUBTITLE:
        'Enter your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP: 'STEP',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_NUMBER: '/ 2',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_CONTAINER_TITLE: 'contact lenses prescription',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_1_TITLE:
        'Select the contact lenses specified in your prescription.',
    MYPROFILE_MY_PRESCRIPTIONS_CONTACTS_STEP_1_EDIT_TITLE:
        'Select the contact lenses brand you find listed in your prescription.',
    MYPROFILE_MY_PRESCRIPTIONS_PRESCRIPTION_SAVED:
        'Choose one of your saved prescriptions or add a new one below.',
    MYPROFILE_MY_PRESCRIPTIONS_TITLE: 'My prescriptions',
    MYPROFILE_MY_PRESCRIPTIONS_NO_PRESCRIPTION_SAVED:
        'Save your prescription to your account for a quick and easy checkout.',
    MYPROFILE_MY_PRESCRIPTIONS_NO_PRESCRIPTION_SAVED_2:
        'You can even save multiple prescriptions if you like!',
    MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_TITLE: 'Add a new prescription',
    MYPROFILE_MY_PRESCRIPTIONS_EDIT_PRESCRIPTION_TITLE: 'Edit your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_BUTTON: 'Add new prescription',
    MYPROFILE_MY_PRESCRIPTIONS_SAVE_PRESCRIPTION_BUTTON: 'Save prescription',
    MYPROFILE_MY_PRESCRIPTIONS_ENTER_PRESCRIPTION: 'Enter your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_BACK_TO_PRESCRIPTIONS: 'Back to My Prescriptions',
    MYPROFILE_MY_PRESCRIPTIONS_BACK_TO_PRESCRIPTIONS_MOBILE: 'Back',
    MYPROFILE_MY_PRESCRIPTIONS_VALID_PRESCRIPTION_CHECKBOX:
        'By clicking this box, I confirm that the prescription values entered above are taken from a valid (not expired) prescription issued to me, signed by a licensed optometrist or ophthalmologist.',
    MYPROFILE_MY_PRESCRIPTIONS_PRESCRIPTION_NAME: 'Prescription Name*',
    MYPROFILE_MY_PRESCRIPTIONS_PATIENT_FIRST_NAME: 'Patient first name',
    MYPROFILE_MY_PRESCRIPTIONS_PATIENT_LAST_NAME: 'Patient last name',
    MYPROFILE_MY_PRESCRIPTIONS_PATIENT_DOB: 'Patient date of birth',
    MYPROFILE_MY_PRESCRIPTIONS_GENERIC_FIELD_CANNOT_BE_EMPTY: 'The field cannot be empty',
    MYPROFILE_MY_PRESCRIPTIONS_FIELD_CANNOT_BE_EMPTY: 'The {FORM_FIELD} field cannot be empty',
    MYPROFILE_MY_PRESCRIPTIONS_FIELD_CANNOT_BE_EMPTY_NAME: '{FORM_FIELD} field cannot be empty',
    MYPROFILE_MY_PRESCRIPTIONS_HOW_TO_READ: 'How to read your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_DEFAULT_PD:
        'You can select the default settings of 61 for women and 64 for men if you have an average or low prescription. If you have a strong prescription or if you want to know your exact PD, please',
    MYPROFILE_MY_PRESCRIPTIONS_DEFAULT_MEASURE_PD: 'measure your PD',
    MYPROFILE_MY_PRESCRIPTIONS_PUPILLARY_DISTANCE_TITLE: 'What is PD (Pupillary distance)',
    MYPROFILE_MY_PRESCRIPTIONS_TWO_PD_NUMBERS: 'I have 2 Pupillary distance numbers',
    MYPROFILE_MY_PRESCRIPTIONS_PD_TITLE: 'Pupillary Distance',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_PRESCRIPTION: 'EYEWEAR PRESCRIPTION',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_PRESCRIPTION_MOBILE: 'EYEWEAR',
    MYPROFILE_MY_PRESCRIPTIONS_ONLINE: 'UPLOADED ONLINE',
    MYPROFILE_MY_PRESCRIPTIONS_IN_STORE: 'UPLOADED IN STORE',
    MYPROFILE_MY_PRESCRIPTIONS_CL_PRESCRIPTION: 'CONTACT LENSES PRESCRIPTION',
    MYPROFILE_MY_PRESCRIPTIONS_CL_PRESCRIPTION_MOBILE: 'CONTACT LENSES',
    MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_INITIALS: 'OD',
    MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_NAME: '(Right)',
    MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_INITIALS: 'OS',
    MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_NAME: '(Left)',
    MYPROFILE_MY_PRESCRIPTIONS_PRISM_VALUES: 'My prescription includes prism values',
    MYPROFILE_MY_PRESCRIPTIONS_BOTH_EYE: 'Same prescription for both eyes',
    MYPROFILE_MY_PRESCRIPTIONS_NAME_EMPTY_ERROR: 'Prescription name field cannot be empty.',
    MYPROFILE_MY_PRESCRIPTIONS_NAME_ERROR: 'Please enter a valid prescription name',
    MYPROFILE_MY_PRESCRIPTIONS_VALUES_ERROR: 'Please enter your prescription values.',
    MYPROFILE_MY_PRESCRIPTIONS_PD_ERROR:
        'Please input your pupillary distance, if you don’t have it you can use the default from the above',
    MYPROFILE_MY_PRESCRIPTIONS_PD_ERROR_MEASURE: 'or you can ',
    MYPROFILE_MY_PRESCRIPTIONS_SHOW_PRESCRIPTION_BUTTON: 'Show prescription',
    MYPROFILE_MY_PRESCRIPTIONS_SHOW_PRESCRIPTION_DETAILS_BUTTON: 'Show prescription details',
    MYPROFILE_MY_PRESCRIPTIONS_OLDER_ONE_YEAR_1:
        'This prescription was uploaded 1 year ago. Please check if it is still valid or ',
    MYPROFILE_MY_PRESCRIPTIONS_EXPIRES_1: 'Your prescription has expired, ',
    MYPROFILE_MY_PRESCRIPTIONS_EXPIRES_2: ' to renew it.',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_EXPIRED: 'Expired on ',
    MYPROFILE_MY_PRESCRIPTIONS_OLDER_ONE_YEAR_2: ' today.',
    MYPROFILE_MY_PRESCRIPTIONS_BOOK_EYE_EXAM: 'book an eye exam',
    MYPROFILE_MY_PRESCRIPTIONS_LOAD_MORE_PRESCRIPTIONS: 'LOAD MORE (10)',
    MYPROFILE_MY_PRESCRIPTIONS_OD_MODAL: 'OD (Right)',
    MYPROFILE_MY_PRESCRIPTIONS_OS_MODAL: 'OS (Left)',
    MYPROFILE_MY_PRESCRIPTIONS_PWR_SPH_MODAL: 'PWR/SPH',
    MYPROFILE_MY_PRESCRIPTIONS_SPH_MODAL: 'SPH (Sphere)',
    MYPROFILE_MY_PRESCRIPTIONS_PWR_SPH_MODAL_MOBILE: '',
    MYPROFILE_MY_PRESCRIPTIONS_CYL_MODAL: 'CYL (Cylinder)',
    MYPROFILE_MY_PRESCRIPTIONS_AXIS_MODAL: 'AXIS',
    MYPROFILE_MY_PRESCRIPTIONS_ADD_MODAL: 'ADD',
    MYPROFILE_MY_PRESCRIPTIONS_PD_MODAL: 'Pupillary Distance',
    MYPROFILE_MY_PRESCRIPTIONS_GO_BACK_MODAL_TITLE_1: 'Are you sure you want to go back?',
    MYPROFILE_MY_PRESCRIPTIONS_GO_BACK_MODAL_TITLE_2: 'Your changes will not be saved.',
    MYPROFILE_MY_PRESCRIPTIONS_GO_BACK_MODAL_YES_LABEL: 'YES, GO BACK',
    MYPROFILE_MY_PRESCRIPTIONS_GO_BACK_MODAL_NO_LABEL: 'NO, CONTINUE',
    MYPROFILE_MY_PRESCRIPTIONS_DELETE_MODAL_TITLE:
        'Are you sure you want to delete this prescription?',
    MYPROFILE_MY_PRESCRIPTIONS_DELETE_MODAL_REMOVE_CTA_LABEL: 'YES, DELETE THIS PRESCRIPTION',
    MYPROFILE_MY_PRESCRIPTIONS_CLOSE_MODAL_REMOVE_CTA_LABEL: 'NO, KEEP IT',
    ADD_PRESCRIPTION_STEP_1_CHECKBOX: 'I wear different types of contact lenses for each eye',
    ADD_PRESCRIPTION_STEP_1_RIGHT: 'OD (Right eye)',
    ADD_PRESCRIPTION_STEP_1_LEFT: 'OS (Left eye)',
    ADD_PRESCRIPTION_STEP_1_BUTTON: 'continue',
    ADD_PRESCRIPTION_STEP_1_SELECTBOX_PLACEHOLDER: 'Select or type your brand',
    ADD_PRESCRIPTION_STEP_1_VERTICAL: 'Vertical (Δ)',
    ADD_PRESCRIPTION_STEP_1_BASE_DIRECTION: 'Base Direction',
    ADD_PRESCRIPTION_STEP_1_BASE_HORIZONTAL: 'Horizontal (Δ)',
    ADD_PRESCRIPTION_STEP_1_ADD_PLACEHOLDER: 'None',
    ADD_PRESCRIPTION_ERROR_PRISM_BASE: 'Please choose the base direction for your prism',
    ADD_PRESCRIPTION_ERROR_PRISM: 'Please choose the prism value',
    MYPROFILE_MY_PRESCRIPTIONS_PRISM_VALUES_ERROR: 'Complete the missing values',
    PRESCRIPTION_ERROR_CHECKBOX_CONFIRM: 'This is required to proceed',
    MYPROFILE_MY_PRESCRIPTIONS_PD_RIGHT: 'Right',
    MYPROFILE_MY_PRESCRIPTIONS_PD_LEFT: 'Left',
    ADD_PRESCRIPTION_WARNING_FORM_1:
        'You’ve inserted 1 positive and 1 negative value, which is very rare.',
    ADD_PRESCRIPTION_WARNING_FORM_2:
        'We suggest double checking your prescription. If this is correct, you can proceed.',
    ADD_PRESCRIPTION_WARNING_PD_1:
        'The selected PD is smaller than average, we suggest double checking your prescription.',
    ADD_PRESCRIPTION_WARNING_PD_2:
        'You can leave the default setting of 63 which is the average measurement for adults.',
    ADD_PRESCRIPTION_WARNING_PD_3:
        'If we need any more information about your prescription, one of our experts will be in touch.',
    ADD_PRESCRIPTION_STEP_AXIS_EMPTY_ERROR:
        'The AXIS values you’ve inserted are not correct! If CYL value is higher or lower than 0, AXIS values can’t be 0.',
    ADD_PRESCRIPTION_STEP_AXIS_ERROR:
        'The AXIS values you’ve inserted are not correct! These values must be between 1 and 180.',
    MYPROFILE_MY_PRESCRIPTIONS_PD_MEASURE_WARNING: 'measure your PD.',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD: 'Uploaded on',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE: 'Last updated: ',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATE: 'Just updated',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_EDIT: 'EDIT',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_DELETE: 'DELETE',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY: 'Today',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY: 'Yesterday',
    MYPROFILE_MY_PRESCRIPTION_EDIT_POPUP_1:
        'Any changes to your prescription will not be applied to current orders.',
    MYPROFILE_MY_PRESCRIPTION_EDIT_POPUP_2:
        'If you need help with an existing order, please <a href="/to-us/contact-us">contact Customer Service</a>.',
    MYPROFILE_MY_PRESCRIPTIONS_SUBTITLE_PREVIEW_CL:
        'We’ll use this information to make sure everything in your order is correct. We’ve got you covered.',
    MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_PRESCRIPTION:
        'OD stands for "oculus dexter" which is Latin for "right eye"',
    MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_PRESCRIPTION:
        'OS stands for "oculus sinister" which is Latin for “left eye”.',
    MYPROFILE_MY_PRESCRIPTIONS_SPH_PRESCRIPTION:
        'They mean the same thing: the strength of your prescription. Pay attention to the - or + sign: the + sign indicates a problem with near vision (farsightedness), the - sign indicates a problem in distance vision (myopia).',
    MYPROFILE_MY_PRESCRIPTIONS_BC_PRESCRIPTION:
        'A fundamental parameter for the lenses to be comfortable, for example it determines the adherence of the lens to the eye. It’s usually a number between 8 and 10.',
    MYPROFILE_MY_PRESCRIPTIONS_DIA_PRESCRIPTION:
        'The diameter indicates the size of the lens. It’s usually a number between 13 and 15.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_BUTTON: 'ADD TO CART',
    MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_NAME_NOT_EDIT: 'OD (Right)',
    MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_NAME_NOT_EDIT: 'OS (Left)',
    MYPROFILE_MY_PRESCRIPTIONS_ANNUAL_SUPPLY_1: 'Save up to $##NUMVALUE##',
    MYPROFILE_MY_PRESCRIPTIONS_SIX_MONTH_SUPPLY_1: 'Save up to $##NUMVALUE##',
    MYPROFILE_MY_PRESCRIPTIONS_ANNUAL_SUPPLY_2:
        ' when you buy an annual supply of ###NUMBOX### boxes!',
    MYPROFILE_MY_PRESCRIPTIONS_SIX_MONTH_SUPPLY_2:
        ' when you buy a 6-months supply of ###NUMBOX### boxes!',
    MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTIONS_DEAFAULT: 'Select your prescription type',
    MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTIONS_DEAFAULT_CONTAINER:
        'Choose the prescription you want to save',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_PRESCRIPTION_DEFAULT: 'EYEWEAR',
    MYPROFILE_MY_PRESCRIPTIONS_CL_PRESCRIPTION_DEFAULT: 'CONTACT LENSES',
    MYPROFILE_MY_PRESCRIPTIONS_CL_FIRST_NAME_ERROR: 'Please enter a valid first name',
    MYPROFILE_MY_PRESCRIPTIONS_CL_LAST_NAME_ERROR: 'Please enter a valid last name',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR:
        'Please search the eye doctor that issued and signed your current prescription.',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR_ERROR_1: "We couldn't find your doctor.",
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR_ERROR_2: 'Please search again or ',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR_ERROR_2_CLICKED: 'add a new doctor.',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_TITLE_ADD: 'Add new doctor',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_TITLE: 'Search your eye doctor by',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_BACK: 'Back to Search Doctor',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_AGAIN: 'Find another doctor',
    MYPROFILE_MY_PRESCRIPTIONS_FORM_ERROR_ADD: 'Oops! You need to add the missing information',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR_CHOOSE: 'CHOOSE',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_DOCTOR_NAME: 'Doctor name',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_CLINIC_NAME: 'Clinic name',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_ADDRESS: 'Address',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_ADD_MOBILE_1: 'Didn’t find your doctor? ',
    MYPROFILE_MY_PRESCRIPTIONS_SEARCH_ADD_MOBILE_2: 'Add manually',
    MYPROFILE_MY_PRESCRIPTIONS_FILE_TOO_BIG_LABEL: 'File is too big',
    MYPROFILE_MY_PRESCRIPTIONS_QUANTITY_ERROR:
        'Please select the number of boxes before proceeding.',
    MYPROFILE_MY_PRESCRIPTIONS_SUBTOTAL: '##NUMBOX## boxes subtotal $##NUMVALUE##',
    MYPROFILE_MY_PRESCRIPTIONS_PLACEHOLDER_TEXT_1: 'Contact lenses',
    MYPROFILE_MY_PRESCRIPTIONS_PLACEHOLDER_TEXT_2: 'Purchased in store',
    MYPROFILE_MY_PRESCRIPTIONS_UPLOAD_IT_TEXT_1:
        'Scan or take a picture of your prescription and upload it in digital format.',
    MYPROFILE_MY_PRESCRIPTIONS_UPLOAD_IT_TEXT_2:
        'We accept the following file formats: .pdf, .png .jpeg .gif .tiff .bmp .docx (max 10 MB).',
    MYPROFILE_MY_PRESCRIPTIONS_UPLOAD_IT_NOTE_PROCESSING: 'This may lengthen your order processing',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_TITLE: 'How to read your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_SEE_EXAMPLE:
        'See an example of your contacts prescription',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_OPTION_ONE: 'Written Prescription',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_OPTION_TWO: 'On box of contacts',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_POWER: 'POWER',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_POWER_BOX: 'PWR (D)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_BC: 'BC',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_DIA: 'DIA',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_CYL: 'CYL',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_AXIS: 'AXIS',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_ADD: 'ADD',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TITLE: 'Eye',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_1: 'Your ',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_2: 'right eye (OD) ',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_3: 'is always listed before your ',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_4: 'left ',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_EYE_TEXT_5: 'eye (OS)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TITLE: 'Power (PWR) or Sphere (SPH)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_1:
        'This shows whether you’re far (-) or nearsighted (+)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_POWER_TEXT_2:
        'and how much correction your eyes require.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TITLE: 'Base Curve (BC)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_1:
        'The base curve, which is usually a number between 8',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_2:
        'and 10, measures the curve of the lens and helps',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_BC_TEXT_3:
        'determine how comfortable the contacts are.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TITLE: 'Diameter (DIA)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_1:
        'The diameter indicates the width that best fits your',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_DIA_TEXT_2:
        'eye and is usually a number between 13 and 15.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TITLE: 'Cylinder (CYL)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_1:
        'CYL represents the added correction for astigmatism',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_CYL_TEXT_2:
        'and is usually a value between -2.25 and -0.75.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_AXIS_TITLE: 'AXIS',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_AXIS_TEXT:
        'It’s usually a value between 0° and 180°.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TITLE: 'Addition (ADD)',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_1:
        'Prescriptions can include an additional indication of',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_2:
        '"high", "medium" or "low" (in one or both eyes) to',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEGEND_ADD_TEXT_3: 'correct near vision.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_RIGHT_BOX_1: 'R',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_RIGHT_BOX_2: 'O.D.',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEFT_BOX_1: 'L',
    MYPROFILE_MY_PRESCRIPTIONS_CL_HOW_TO_READ_LEFT_BOX_2: 'O.S.',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TITLE: 'How to read your prescription',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_SUBTITLE:
        'If you have a prescription for eyeglasses, the prescription information will typically include the following:',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_1: 'OD (Right Eye) / OS (Left Eye)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_2: 'SPH (Sphere)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_3: 'CYL (Cylinder)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_4: 'Axis',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_5: 'Add',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_RIGHT_1: 'OD (Right Eye)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_RIGHT_1:
        'OD stands for "oculus dexter" which is Latin for "right eye".',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_LEFT_1: 'OS (Left Eye)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_LEFT_1:
        'OS stands for "oculus sinister" which is Latin for “left eye”.',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_2:
        'Sphere (SPH) - also known as Power (PWR)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_2:
        "They mean the same thing: the strength of your prescription. If you're nearsighted you will have a minus (-) before your values, and if you’re or farsighted you will have a plus (+).",
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_3: 'CYL (Cylinder)',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_3:
        'This is for people with astigmatism. This is when one part of the eye needs more correction than the rest. The Cylinder value is written with a minus (-) sign.',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_4: 'Axis',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_4:
        'This is only for people with astigmatism. The axis is a number between 0 and 180 and determines the orientation of the Cylinder (CYL).',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_5: 'Add',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_5:
        'This indicates the additional magnifying power that is added to the lens to correct presbyopia, a common age-related condition that affects near vision.',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BOTTOMTEXT:
        'If any of this information isn’t included in your prescription, you can leave the field blank.',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT:
        'Not sure about something? Call our Customer Service experts on ',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT_MOBILE_PART_1:
        'Not sure about something?',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT_MOBILE_PART_2:
        'Call our Customer Service experts on ',
    MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURENUMBER: '1-877-848-8476',
    MYPROFILE_MY_ORDERS_ONLINE_LABEL: 'ONLINE PURCHASE',
    MYPROFILE_MY_ORDERS_RETAIL_LABEL: 'IN STORE PURCHASE',
    MYPROFILE_MY_ORDERS_RETAIL_WRAPPER_SUMMARY_NOT_BUYABLE:
        'One or more products in this order are not available for reorder',
    OPTHY_MODAL_CONTAINER_TTLE: 'How to measure your PD',
    OPTHY_MODAL_CONTAINER_SUBTITLE:
        'Your Pupillary Distance, or PD, is the distance in millimeters (mm) from the center of one pupil to the center of the other. It indicates exactly which part of the lens you look through, ensuring optimal comfort and clarity. You can measure with the app or manually.',
    OPTHY_MODAL_CONTAINER_WITH_APP_LABEL: 'with the app',
    OPTHY_MODAL_CONTAINER_MANUALLY_LABEL: 'manually',
    OPTHY_MODAL_CONTAINER_APP_TEXT_BOLD: 'Get your glasses just right with Opthy.',
    OPTHY_MODAL_CONTAINER_APP_TEXT_MEASURES:
        'Opthy measures your Pupillary Distance, allowing you to find the most comfortable, personalized fit.',
    OPTHY_MODAL_CONTAINER_APP_TEXT_AVAIABLEON: 'App available on iPhone X and above.',
    OPTHY_MODAL_CONTAINER_APP_TEXT_PROBLEMSWITH_1: 'Problems with the QR code?',
    OPTHY_MODAL_CONTAINER_APP_TEXT_PROBLEMSWITH_2: 'See the app on the App Store.',
    WARNING_BANNER_LABEL:
        'The selected PD is smaller than average, we suggest double checking your prescription. If you don’t have the PD here ',
    WARNING_HELP_LABEL: 'how to measure it',
    WARNING_MODAL_CONTAINER_TITLE_LABEL: 'How to measure your pupillary distance',
    WARNING_MODAL_CONTAINER_TEXT_1_LABEL:
        'Your Pupillary Distance, or PD, is the distance in millimeters (mm) between the center of one pupil to the center of the other.',
    WARNING_MODAL_CONTAINER_TEXT_2_LABEL:
        "Can't find your PD? No problem. You can leave the default setting of 63 which is the average measurement for adults. If we need any more information about your prescription, one of our experts will be in touch.",
    WARNING_MODAL_CONTAINER_TEXT_3_LABEL:
        'If you want, you can measure your PD yourself by following these steps:',
    WARNING_MODAL_CONTAINER_ELEMENT_1_LABEL:
        'Grab a small ruler in one hand, and have your pencil and paper handy.',
    WARNING_MODAL_CONTAINER_ELEMENT_2_LABEL:
        'Now position yourself approximately 8 inches (20 cm) away from a mirror.',
    WARNING_MODAL_CONTAINER_ELEMENT_3_LABEL:
        'Close your left eye and align the 0 mm over the center of your right pupil.',
    WARNING_MODAL_CONTAINER_ELEMENT_4_LABEL:
        'Measure the distance from your right to your left pupil.',
    WARNING_MODAL_CONTAINER_ELEMENT_5_LABEL:
        'The number that lines up directly over your left pupil is your PD (An average PD for an adult ranges between 58 and 65).',
    ERROR_SUBMIT_PRESCRIPTION_UPLOAD: 'Error with add prescription, please try again',
    ERROR_SUBMIT_PRESCRIPTION_POST: 'Error with upload prescription, please try again',
    ERROR_SUBMIT_PRESCRIPTION_SKU_LEFT: 'The prescription you selected is not available',
    ERROR_SUBMIT_PRESCRIPTION_SKU_RIGHT: 'The prescription you selected is not available',
};
